import { render, staticRenderFns } from "./PerfectPay.vue?vue&type=template&id=84cfa79a&"
import script from "./PerfectPay.vue?vue&type=script&lang=js&"
export * from "./PerfectPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports